import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { db } from '../config/fbConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import Logo from '../images/school_logo.png';
import Back from '../images/back3.webp';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

const StudentLogin = () => {
  const [firstName, setFirstName] = useState("");
  const [admissionNumber, setAdmissionNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [signingIn, setSigningIn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back).then(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSigningIn(true);

    try {
      // Trim whitespace from inputs
      const trimmedFirstName = firstName.trim();
      const trimmedAdmissionNumber = admissionNumber.trim();

      // Query Firestore (case-sensitive)
      const studentsRef = collection(db, "students");
      const q = query(
        studentsRef,
        where("firstName", "==", trimmedFirstName),
        where("admissionNumber", "==", trimmedAdmissionNumber)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const student = { ...querySnapshot.docs[0].data(), id: querySnapshot.docs[0].id };
        setSigningIn(false);
        navigate("/student-dashboard", { state: { student } });
      } else {
        // If no match, try case-insensitive matching by fetching all and comparing
        const allStudentsRef = collection(db, "students");
        const allQuery = query(allStudentsRef, where("admissionNumber", ">=", ""));
        const allSnapshot = await getDocs(allQuery);
        
        let matchedStudent = null;
        allSnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.firstName?.trim().toLowerCase() === trimmedFirstName.toLowerCase() &&
              data.admissionNumber?.trim().toLowerCase() === trimmedAdmissionNumber.toLowerCase()) {
            matchedStudent = { ...data, id: doc.id };
          }
        });
        
        if (matchedStudent) {
          setSigningIn(false);
          navigate("/student-dashboard", { state: { student: matchedStudent } });
        } else {
          throw new Error("Invalid first name or admission number");
        }
      }
    } catch (err) {
      setSigningIn(false);
      setError(err.message);
      setShowModal(true);
    }
  };

  if (loading) {
    return <Loader text={"LOADING"} />;
  }

  return (
    <>
      {signingIn && <Loader text={"AUTHENTICATING"} />}
      <div className="top-elements row align-center space-between">
        <Link to="/" className="back-link">
          <i className="fa-solid fa-arrow-left size3"></i>
        </Link>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>
      <div className="login-page-items column align-center" style={{ backgroundImage: `url(${Back})` }}>
        <div className="form-items">
          <p className="login-heading size3 align-center justify-center">STUDENT LOGIN</p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              id="login-firstname"
              className="input-field"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <input
              type="text"
              id="login-admission"
              className="input-field"
              placeholder="Admission Number"
              value={admissionNumber}
              onChange={(e) => setAdmissionNumber(e.target.value)}
              required
            />
            <div className="row align-center justify-center">
              <button type="submit" className="login-button">
                SIGN IN
              </button>
            </div>
          </form>
        </div>
      </div>
      {showModal && (
        <SuccessModal
          icon="xmark"
          iconColor="red"
          message={error}
          onClose={() => {
            setError("");
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default StudentLogin;